module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-456.3280b07.woff2";